export type UploadFilesSequentiallyResult = {
  uploadedCount: number
  skippedCount: number
  error?: unknown
}

export type UploadFilesSequentiallyOptions = {
  /** Return false to skip the file and continue; throw to abort the whole batch. May be async. */
  validateFile?: (file: File) => boolean | void | Promise<boolean | void>
  onFileSkipped?: (file: File) => void
  stopOnError?: boolean
}

export async function uploadFilesSequentially(
  files: readonly File[] | FileList | null,
  uploadOne: (file: File) => Promise<unknown>,
  options?: UploadFilesSequentiallyOptions,
): Promise<UploadFilesSequentiallyResult> {
  const batch = files == null ? [] : Array.isArray(files) ? [...files] : Array.from(files)
  if (batch.length === 0) {
    return { uploadedCount: 0, skippedCount: 0 }
  }

  const stopOnError = options?.stopOnError ?? true
  let uploadedCount = 0
  let skippedCount = 0
  let error: unknown

  for (const file of batch) {
    if (options?.validateFile) {
      try {
        const valid = await options.validateFile(file)
        if (valid === false) {
          skippedCount += 1
          options.onFileSkipped?.(file)
          continue
        }
      } catch (e) {
        error = e
        break
      }
    }

    try {
      await uploadOne(file)
      uploadedCount += 1
    } catch (e) {
      error = e
      if (stopOnError) break
    }
  }

  return { uploadedCount, skippedCount, error }
}
